/* eslint-disable no-console */
import { ENV_PROD, LOG_LEVEL } from './env';
import { noOperation } from './function';

const LOG_LEVEL_MODEST = 'MODEST';
const LOG_LEVEL_VERBOSE = 'VERBOSE';

type LogFn = (...args: unknown[]) => void;
type NoOpFn = (...args: unknown[]) => boolean;

const noOperationFn = noOperation as unknown as NoOpFn;

const noopAsLog: LogFn = (..._args: unknown[]) => undefined;

type Output = {
  LEVEL: string;
  clear: LogFn;
  error: LogFn;
  greet: LogFn;
  handles: (func: unknown) => boolean;
  log: LogFn;
  warn: LogFn;
};

const output: Output = {
  LEVEL: LOG_LEVEL,
  clear: ENV_PROD ? console.clear.bind(console) : noopAsLog,
  error: ENV_PROD ? console.error.bind(console) : noopAsLog,
  greet: ENV_PROD ? console.log.bind(console) : noopAsLog,
  handles: (func: unknown) => func !== noOperationFn,
  log: noopAsLog,
  warn: noopAsLog,
};

if (output.LEVEL === LOG_LEVEL_VERBOSE) {
  output.clear = console.clear.bind(console);
  output.error = console.error.bind(console);
  output.greet = console.log.bind(console);
  output.log = console.log.bind(console);
  output.warn = console.warn.bind(console);
} else if (output.LEVEL === LOG_LEVEL_MODEST) {
  output.clear = console.clear.bind(console);
  output.error = console.error.bind(console);
  output.greet = console.log.bind(console);
  output.warn = console.warn.bind(console);
}

const { clear, error, greet, handles, log, warn } = output;

export { clear, error, greet, handles, log, warn };

export default {
  clear,
  error,
  greet,
  handles,
  log,
  warn,
};
